import * as React from "react";
import Link from "next/link";
import { pushSimpleEvent } from "@nju/data-layer";
import { portalRoutes } from "@nju/routes";
import { A, Button, Heading, Panel, Separator, Text } from "@nju/ui";

export function DashboardHelpPage() {
  const openChat = React.useCallback(() => {
    if ("closer" in window) {
      // @ts-expect-error missing types
      closer.openWidget();
      pushSimpleEvent({
        event: "activity_chat",
        eventName: "chat_open",
      });
    }
  }, []);

  const handlePushDataLayer = React.useCallback(() => {
    pushSimpleEvent({ event: "activity_faq", eventName: "faq_page" });
  }, []);

  return (
    <div className="grid gap-4 grid-cols-[auto] from-desktop:grid-cols-2">
      <Panel testId="help-chat-panel">
        <Heading font="ttfirs" tone="neutral" variant="h4" weight="bold">
          chcesz zgłosić błąd lub potrzebujesz pomocy?
        </Heading>
        <Separator size="xs" tone="invisible" />
        <Text>Napisz do konsultanta na czacie.</Text>
        <Separator size="s" tone="invisible" />
        <Button
          onPress={openChat}
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
        >
          włącz czat
        </Button>
      </Panel>
      <Panel testId="move-to-help-page-panel">
        <div className="flex flex-col justify-between h-full">
          <Heading font="ttfirs" tone="neutral" variant="h4" weight="bold">
            zapoznaj się z najczęściej zadawanymi pytaniami
          </Heading>
          <Separator
            size={{
              "@onlyMobile": "s",
              "@fromDesktop": "none",
            }}
            tone="invisible"
          />
          <Link href={portalRoutes.mojeKonto.pomoc.faq.get()} passHref={true}>
            <A
              onClick={handlePushDataLayer}
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "m",
              }}
              variant="secondary"
            >
              przejdź do strony pomocy
            </A>
          </Link>
        </div>
      </Panel>
    </div>
  );
}
